import React from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import ConnectedTeamRoleCard from "./ConnectedTeamRoleCard";
import ConnectedSelectedTeamRoleCard from "./ConnectedSelectedTeamRoleCard";

const DetectTeamRoleCard = ({ selected = false, ...props }) => {
    const { values } = useFormikContext();
    const { Team = "" } = values;

    return selected && Team.length > 0 ? (
        <ConnectedSelectedTeamRoleCard {...props} />
    ) : (
        <ConnectedTeamRoleCard {...props} />
    );
};

DetectTeamRoleCard.propTypes = {
    selected: PropTypes.bool,
};

export default DetectTeamRoleCard;
